import { IStaticProps } from 'core-components/sitebuilder/models/IWidget'

type TValues = number | boolean | string | object

export const prepareStaticParamsTypes = (staticParam: IStaticProps): TValues => {
  if (staticParam.paramType === 'number') {
    return Number(staticParam.paramValue)
  } else if (staticParam.paramType === 'boolean') {
    return Boolean(staticParam.paramValue)
  } else if (staticParam.paramType === 'string') {
    return String(staticParam.paramValue)
  } else if (staticParam.paramType === 'object') {
    const preparedObjectData = getPreparedObjectData(staticParam)
    const params: Record<string, TValues> = {}
    preparedObjectData.forEach((el) => {
      params[el.paramName] = prepareStaticParamsTypes(el)
    })
    return params
  } else if (staticParam.paramType === 'array') {
    const preparedObjectData = getPreparedObjectData(staticParam)
    const paramsArray: TValues[] = []
    preparedObjectData.forEach((el) => {
      paramsArray.push(prepareStaticParamsTypes(el))
    })
    return paramsArray
  } else if (staticParam.paramType === 'dropdown') {
    return String(staticParam.paramValue)
  } else if (staticParam.paramType === 'multiselect') {
    return staticParam.paramValue instanceof Array ? staticParam.paramValue : []
  }

  return ''
}

const getPreparedObjectData = (staticParam: IStaticProps) => {
  return ((staticParam.paramValue as IStaticProps[]) || []).map((el) => {
    return {
      ...el,
      paramValue: prepareStaticParamsTypes(el),
    }
  }) as IStaticProps[]
}
